<template>
  <div class="digital-factory">
    <div class="solution-banner">
      <img src="@/assets/images/website/solution/digital-factory/banner.png" />
    </div>
    <div class="informatization-construction">
      <div class="website-container">
        <Row class="info-title">
          <Col span="6">
            <h2>信息化基础设施建设</h2>
          </Col>
          <Col>
            <span>模块化数据中心————机房新趋势</span>
            <span>服务器虚拟化技术————服务器资源负载均衡</span>
            <span>桌面云技术————数据与终端分离</span>
          </Col>
        </Row>
        <h3>提供基础网络建设及安防监控网络建设、数据中心机房建设、集控中心建设</h3>
        <div class="info-content">
          <img src="@/assets/images/website/solution/digital-factory/part_1_1.png" style="width:37%;margin:0 5px;" />
          <img alt src="@/assets/images/website/solution/digital-factory/part_1_2.png" style="width:30%;margin:0 5px;" />
          <img alt src="@/assets/images/website/solution/digital-factory/part_1_3.png" style="width:30%;margin:0 5px;" />
        </div>
      </div>
    </div>
    <div class="scada-and-conter">
      <div class="scada">
        <div class="website-container">
          <h2>SCADA系统</h2>
          <div class="scada-content">
            <img alt src="@/assets/images/website/solution/digital-factory/part_2.png" />
          </div>
        </div>
      </div>
      <div class="control-center">
        <div class="website-container">
          <h2>智能集控中心建设</h2>
          <div class="control-content">
            <img alt src="@/assets/images/website/solution/digital-factory/part_3_2.png" />
            <img alt src="@/assets/images/website/solution/digital-factory/part_3_1.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="digital-workshop">
      <div class="website-container">
        <h2>数字化车间与设备远程监控</h2>
        <Row>
          <Col class="workshop-list" span="10">
            <div class="workshop-list-item">
              <img alt src="@/assets/images/website/solution/digital-factory/dot.png" />
              <span>建设设备数据监控中心，统一企业数据标准</span>
            </div>
            <div class="workshop-list-item">
              <img alt src="@/assets/images/website/solution/digital-factory/dot.png" />
              <span>全天候监视、分析和跟踪设备的关键参数</span>
            </div>
            <div class="workshop-list-item">
              <img alt src="@/assets/images/website/solution/digital-factory/dot.png" />
              <span>利用大数据技术，帮助企业进行效能提升</span>
            </div>
            <div class="workshop-list-item">
              <img alt src="@/assets/images/website/solution/digital-factory/dot.png" />
              <span>使用移动通讯技术，随时随地了解设备状况</span>
            </div>
            <div class="workshop-list-item">
              <img alt src="@/assets/images/website/solution/digital-factory/dot.png" />
              <span>建设远程诊断运行维护平台，享受专家可视化远程诊断服务</span>
            </div>
          </Col>
          <Col class="workshop-right" span="14">
            <img alt src="@/assets/images/website/solution/digital-factory/part_4.png" />
          </Col>
        </Row>
        <div class="workshop-big-screen">
          <img alt src="@/assets/images/website/solution/digital-factory/part_5.png" />
        </div>
        <div class="workshop-system">
          <img alt src="@/assets/images/website/solution/digital-factory/part_6.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.solution-banner {
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
  }
}
.informatization-construction {
  padding: 30px 0;
  .info-title {
    line-height: 40px;
    span {
      text-align: center;
      margin-right: 20px;
      align-items: center;
      padding: 8px 16px;
      color: #fff;
      background-color: #3a7ec3;
    }
  }
  h3 {
    text-align: center;
    margin: 20px 0;
  }
}
.scada-and-conter {
  background: linear-gradient(#f6f7f9, #ffffff);
}
.scada {
  padding: 30px 0;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  .scada-content {
    width: 900px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
.control-center {
  padding: 30px 0;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  .control-content {
    text-align: right;
    img {
      margin-left: 20px;
    }
  }
}
.digital-workshop {
  background: linear-gradient(#f6f7f9, #ffffff);
  padding: 30px 0;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  .workshop-list {
    padding: 30px;
    .workshop-list-item {
      line-height: 28px;
      margin: 20px 0;
      img {
        padding-right: 6px;
      }
    }
  }
  .workshop-right {
    text-align: right;
    width: 100%;
  }
  .workshop-big-screen {
    margin-top: 20px;
    img {
      width: 1280px;
    }
  }
  .workshop-system {
    margin-top: 20px;
    img {
      width: 90%;
    }
  }
}
</style>
